__turbopack_context__.v({
  "desk": "DeskScroller-module__rz3bOG__desk",
  "frame": "DeskScroller-module__rz3bOG__frame",
  "hint": "DeskScroller-module__rz3bOG__hint",
  "scroller": "DeskScroller-module__rz3bOG__scroller",
  "seam": "DeskScroller-module__rz3bOG__seam",
});
